<div class="mt-4">
  <p-table [value]="data.historyEntries$ | async">
    <ng-template pTemplate="header">
      <tr>
        <th i18n>Date</th>
        <th i18n>Description</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-entry>
      <tr>
        <td>{{ entry.createdDateTime | date:'y-m-d-t' }}</td>
        <td>{{ formatHistoryEntry(entry) }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>